import React from "react";
import { Box, Flex } from "../../../assets/ui";
import { StyledSectionWrapper } from "./ui";

const JoinUs = () => {
  return (
    <StyledSectionWrapper>
      <Flex
        display={["flex", "none"]}
        marginBottom="32px"
        height="fit-content"
        marginTop={"-50px"}
      >
        <img src="/images/dj.png" alt="" />
      </Flex>
      <Box width={["100%", "50%"]}>
        <h3>
          We’re growing the team and would love you to join us on our adventure
        </h3>
        <p>
          Every Agent will receive commission from their very first deal. After
          the first 30 days of training if successful, the Agent will then
          receive £1800 per month as a base salary, in addition to the
          commission structure.
        </p>
        <p>
          The commission is owed to the Agent every month for 12 months, (as
          long as the customer is still using the software).
        </p>
        <p>
          The agent, depending on performance of the previous year, will receive
          double the commission % from year 1 and the base salary will go up to
          £2500 per month.
        </p>
      </Box>
      <Box width={["100%", "50%"]} marginLeft={[0, "30px", null, "110px"]}>
        <Box
          display={["none", "flex"]}
          boxShadow=""
          marginBottom="80px"
          marginTop={"-90px"}
        >
          <img src="/images/dj.png" alt="" />
        </Box>
        <h3>Exsportia system</h3>
        <p>
          Exsportia receives commission from of all revenue collected, (payments
          made), via the Exsportia system. For each venue signed, you, the Agent
          will receive 20% of what Exsportia gets paid
        </p>
      </Box>
    </StyledSectionWrapper>
  );
};

export default JoinUs;
